<div class="file-downloader">
  <motif-icon class="doc-icon" [iconFunction]="IconoirEmptyPage"></motif-icon>
  <div class="file-text-container">
    <p>{{ filename }}</p>
    <p>{{ bytesToMB(fileSize) }}MB</p>
  </div>
  <button
    motifButton
    color="primary"
    (click)="downloadExcelFile()"
    aria-label="Download document"
    aria-live="polite"
  >
    <motif-icon [iconFunction]="IconoirDownload"></motif-icon>
  </button>
</div>
